import { z } from 'zod';

export const RowLevelEnum = z.enum([
  'activity',
  'channel',
  'platform',
  'media_row',
  'campaign',
  'ad_group',
  'ad',
]);
